import { useTranslation } from 'react-i18next';
import { HierarchicalLevel } from '../../participantEnums';

export const useHierarchicalLevels = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: HierarchicalLevel.FOUNDER,
      label: t('participants.enums.hierarchicalLevel.FOUNDER'),
    },
    {
      value: HierarchicalLevel.CXO,
      label: t('participants.enums.hierarchicalLevel.CXO'),
    },
    {
      value: HierarchicalLevel.DECISION_MAKER,
      label: t('participants.enums.hierarchicalLevel.DECISION_MAKER'),
    },
    {
      value: HierarchicalLevel.MANAGER,
      label: t('participants.enums.hierarchicalLevel.MANAGER'),
    },
    {
      value: HierarchicalLevel.EMPLOYEE,
      label: t('participants.enums.hierarchicalLevel.EMPLOYEE'),
    },
  ];
};
